import { WidgetInitializer } from "../functions/widget-initializer";
import { Constants } from "../functions/constants";
import VueSocialSharing from 'vue-social-sharing';

Vue.use(VueSocialSharing);

var widgetInitializer = new WidgetInitializer(Constants.COMPONENTS.SOCIAL_SHARE);
GlobalApp.registerInitializationHandler(Constants.COMPONENTS.SOCIAL_SHARE, function () {
    widgetInitializer.initialize(initSocialShareApp);
});

function initSocialShareApp(element) {
    var vueApp = new Vue({
        el: '#' + element.id,

        data: {
            thisPageUrl: "",
            thisPageTitle: ""
        },

        methods: {
            sharePrint: function sharePrint() {
                window.print();
            }
        },

        created: function () {
            this.thisPageUrl = window.location.href
            this.thisPageTitle = document.title
        }
    });
    return vueApp.$el;
}